/* eslint-disable camelcase */
import api from './api';
import { UploadSeed } from './upload';

const uploadSeed = (
    mimeType: string,
    contentMd5: string,
    url: string
): Promise<UploadSeed> =>
    api.request<UploadSeed>({
        method: 'GET',
        url,
        params: {
            mime_type: mimeType,
            content_md5: contentMd5,
        },
        skipCamelization: true,
    });

export default { uploadSeed };
